import { FC, useCallback } from "react";
import { StrikeExtension } from "@remirror/extension-strike";
import { useActive, useCommands } from "@remirror/react";
import { CommandButton, CommandButtonProps } from "@remirror/react-ui";

export interface ToggleStrikeButtonProps
  extends Omit<
    CommandButtonProps,
    "commandName" | "active" | "enabled" | "attrs" | "onSelect"
  > {
  onBlur: () => void;
}

export const ToggleStrikeButton: FC<ToggleStrikeButtonProps> = (props) => {
  const { toggleStrike } = useCommands<StrikeExtension>();

  const handleSelect = useCallback(() => {
    if (toggleStrike.enabled()) {
      toggleStrike();
      props.onBlur();
    }
  }, [props, toggleStrike]);

  const active = useActive<StrikeExtension>().strike();
  const enabled = toggleStrike.enabled();

  return (
    <CommandButton
      {...props}
      commandName="toggleStrike"
      active={active}
      enabled={enabled}
      onSelect={handleSelect}
    />
  );
};
